import './style.scss';

import React from 'react';
import MaskedInput from 'react-text-mask';

class FormField extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasFocus: false,
      error: props.error || null,
      value: props.initialValue || '',
      autofilled: false
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleFocus = this.handleFocus.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.handleAutofill = this.handleAutofill.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.updatedValue &&
      nextProps.updatedValue !== this.props.updatedValue
    ) {
      this.setState({ value: nextProps.updatedValue, error: null });
    }

    if (nextProps.error && nextProps.error !== this.props.error) {
      this.setState({ error: nextProps.error });
    }
  }

  handleChange(e) {
    e.preventDefault();
    const value = e.target.value;
    this.setState({ value });
    if (this.props.onChange) this.props.onChange(value);
  }

  handleFocus() {
    this.setState({ hasFocus: true });
  }

  handleBlur() {
    this.setState({ hasFocus: false });
    if (this.props.validate) {
      const error = this.props.validate(this.state.value) || null;
      this.setState({ error });
    }
  }

  handleAutofill({ animationName }) {
    switch (animationName) {
      case 'onAutoFillCancel':
        this.setState({ autofilled: false });
        break;
      case 'onAutoFillStart':
        this.setState({ autofilled: true });
        break;
    }
  }

  render() {
    const {
      id,
      name,
      labelText,
      inputType,
      placeholder,
      mask,
      textarea,
      inputRef,
      autoFocus
    } = this.props;
    const { value, error, hasFocus, autofilled } = this.state;

    const isFloating = !!value || hasFocus || !!error || autofilled;
    const fieldClass =
      'form-field' +
      (textarea ? ' form-field--textarea' : '') +
      (error ? ' form-field--error' : '');
    const labelClass =
      'form-field__label' +
      (isFloating ? ' form-field__label--floating' : '') +
      (error ? ' form-field__label--error' : '');
    const inputClass =
      'form-field__input' +
      (isFloating ? ' form-field__input--floating' : '') +
      (error ? ' form-field__input--error' : '');

    return (
      <div className={fieldClass}>
        <label htmlFor={id} className={labelClass}>
          {error || labelText}
        </label>
        {textarea ? (
          <textarea
            id={id}
            className={inputClass}
            maxLength="300"
            value={value}
            onChange={this.handleChange}
            onFocus={this.handleFocus}
            onBlur={this.handleBlur}
            ref={inputRef}
          />
        ) : mask ? (
          <MaskedInput
            mask={mask}
            id={id}
            name={name}
            className={inputClass}
            type={inputType || 'text'}
            placeholder={(isFloating && placeholder) || ''}
            disabled={this.props.disabled}
            value={value}
            onChange={this.handleChange}
            onFocus={this.handleFocus}
            onBlur={this.handleBlur}
          />
        ) : (
          <input
            id={id}
            name={name}
            className={inputClass}
            type={inputType || 'text'}
            placeholder={(isFloating && placeholder) || ''}
            disabled={this.props.disabled}
            autoComplete={this.props.autocomplete}
            value={value}
            onChange={this.handleChange}
            onFocus={this.handleFocus}
            onBlur={this.handleBlur}
            onAnimationStart={this.handleAutofill}
            ref={inputRef}
            autoFocus={autoFocus || false}
          />
        )}
      </div>
    );
  }
}

export default FormField;



// WEBPACK FOOTER //
// ./shared/components/ui/formField/index.js